import Feature from 'ol/Feature';
import { GeoJSON, WKT, ReadOptions } from 'ol/format';

export class FormatUtils {

    public static readGeoJson(geoJson: any): Feature {
        let feature: Feature = null;
        const reader: GeoJSON = new GeoJSON();
        feature = reader.readFeature(geoJson);
        return feature;
    }

    public static readWkt(wkt: string, srcProj?: string, destProj?: string): Feature {
        let feature: Feature = null;
        const reader: WKT = new WKT();
        const options: ReadOptions = { dataProjection: srcProj, featureProjection: destProj };
        feature = reader.readFeature(wkt, options);
        return feature;
    }

    public static writeGeoJson(feature: Feature): any {
        let geoJson: any = null;
        const reader: GeoJSON = new GeoJSON();
        geoJson = reader.writeFeatureObject(feature);
        return geoJson;
    }

}




// WEBPACK FOOTER //
// ./libs/map/utils/format.utils.ts